<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiMagnify } from "@mdi/js";
export default {
  name: "MdiMagnify",
  data() {
    return {
      svgPath: mdiMagnify,
    };
  },
};
</script>
